// "demo.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// 데모 계정(DemoScenarioContext) 전용 — 샘플 진단 결과·데모 농장 정보.
const demo = {
  ko: {
    // 로딩 화면
    "loading.alt": "로딩 중",

    // 데모 농장 정보 (Information 탭)
    "farm.name": "농기원",
    "farm.location": "전남광주동함평시",
    // 작물명은 계정이 정한다(demo = cabbage, demo2 = rice)
    "farm.cropName.cabbage": "양배추",
    "farm.cropName.rice": "벼",

    // 샘플 진단 라벨 (kind 별)
    "sample.label.normal": "정상",
    "sample.label.soft-rot": "양배추 무름병",
    "sample.label.sclerotinia": "양배추 균핵병",
    // 해충 샘플 이미지가 들어오면 kind: "pest" 로 쓰인다.
    "sample.label.pest": "해충 위험",
    // 벼(demo2)
    "sample.label.blast": "벼 도열병",
    "sample.label.sheath-blight": "벼 잎집무늬마름병",

    // 샘플 진단 요약 (샘플 별)
    "sample.summary.normal.1": "건강한 결구부와 잎맥 패턴이 확인되었습니다.",
    "sample.summary.normal.2": "잎 표면과 생장점이 정상 범위로 분석되었습니다.",
    "sample.summary.normal.3": "정상 잎맥 구조와 결구 상태가 확인되었습니다.",
    "sample.summary.softRot.1": "수침상 연부 조직 변화가 여러 잎에서 확인되었습니다.",
    "sample.summary.softRot.2": "내엽 접힘 부위의 연화 병반이 분석되었습니다.",
    "sample.summary.softRot.3": "외엽과 내엽의 습윤성 연부 병반이 확인되었습니다.",
    "sample.summary.sclerotinia.1": "병반 경계의 균사성 조직과 습윤 반점이 확인되었습니다.",
    "sample.summary.sclerotinia.2": "불규칙한 갈변 및 균사성 반점이 분석되었습니다.",
    // 벼(demo2)
    "sample.summary.rice.normal.1": "잎색과 분얼 상태가 정상 범위로 확인되었습니다.",
    "sample.summary.rice.normal.2": "잎몸과 잎집에 병반 없이 건전한 생육이 확인되었습니다.",
    "sample.summary.rice.normal.3": "이삭과 잎의 색상이 고르게 정상으로 분석되었습니다.",
    "sample.summary.blast.1": "잎에 방추형 회백색 병반과 갈색 테두리가 확인되었습니다.",
    "sample.summary.blast.2": "잎몸 여러 곳에서 도열병 특유의 눈꼴 병반이 분석되었습니다.",
    "sample.summary.blast.3": "이삭목 부위 갈변과 잎 병반 확산이 확인되었습니다.",
    "sample.summary.sheathBlight.1": "잎집에 타원형 구름 무늬 병반이 확인되었습니다.",
    "sample.summary.sheathBlight.2": "잎집에서 잎으로 번지는 회녹색 병반이 분석되었습니다.",
  },
  en: {
    // 로딩 화면
    "loading.alt": "Loading",

    // 데모 농장 정보 (Information 탭)
    "farm.name": "Agricultural Tech Institute",
    "farm.location": "Hampyeong, Jeonnam",
    "farm.cropName.cabbage": "Cabbage",
    "farm.cropName.rice": "Rice",

    // 샘플 진단 라벨 (kind 별)
    "sample.label.normal": "Healthy",
    "sample.label.soft-rot": "Cabbage soft rot",
    "sample.label.sclerotinia": "Cabbage sclerotinia rot",
    "sample.label.pest": "Pest risk",
    "sample.label.blast": "Rice blast",
    "sample.label.sheath-blight": "Rice sheath blight",

    // 샘플 진단 요약 (샘플 별)
    "sample.summary.normal.1": "Healthy head formation and leaf-vein pattern confirmed.",
    "sample.summary.normal.2": "Leaf surface and growing point analyzed within the normal range.",
    "sample.summary.normal.3": "Normal leaf-vein structure and head condition confirmed.",
    "sample.summary.softRot.1": "Water-soaked soft-tissue changes found on multiple leaves.",
    "sample.summary.softRot.2": "Softened lesions detected at the inner-leaf folds.",
    "sample.summary.softRot.3": "Moist soft-rot lesions found on the outer and inner leaves.",
    "sample.summary.sclerotinia.1": "Mycelial tissue and moist spots found along the lesion margins.",
    "sample.summary.sclerotinia.2": "Irregular browning and mycelial spots detected.",
    "sample.summary.rice.normal.1": "Leaf color and tillering confirmed within the normal range.",
    "sample.summary.rice.normal.2": "Healthy growth confirmed with no lesions on blades or sheaths.",
    "sample.summary.rice.normal.3": "Panicle and leaf color analyzed as uniformly normal.",
    "sample.summary.blast.1": "Spindle-shaped gray-white lesions with brown margins found on the leaves.",
    "sample.summary.blast.2": "Eye-shaped blast lesions detected at several points on the blades.",
    "sample.summary.blast.3": "Neck browning and spreading leaf lesions confirmed.",
    "sample.summary.sheathBlight.1": "Oval cloud-pattern lesions found on the leaf sheaths.",
    "sample.summary.sheathBlight.2": "Gray-green lesions spreading from the sheaths to the blades.",
  },
};

export default demo;
